import React from 'react';
import { Grid, GridColumn, GRID_COL_INDEX_ATTRIBUTE } from "@progress/kendo-react-grid";
import { filterBy, orderBy } from "@progress/kendo-data-query";
import HfKendoComboBox from "../shared/HfKendoComboBox";
import Api from '../../services/api/api';
import './Troubleshooting.css';

export default class Troublshooting extends React.Component {

    constructor(props) {
        super(props);

        const useDefaults = String(process.env.REACT_APP_USE_DEFAULTS).toLowerCase() === 'true';

        this.state = {
            isLoading: false,
            showTable: false,
            data: [],
            currentData: [],
            filter: '',
            skip: 0,
            take: 20,
            procedure: useDefaults ? { "code": "11300", "name": "SHAVING OF 0.5 CENTIMETERS OR LESS SKIN GROWTH OF THE TRUNK ARMS OR LEGS", "wrvu": 0, "chargeAmount": 0, "altAmount": 0, "adminCodes": null, "comment": null, "parentId": null, "label": "11300 - SHAVING OF 0.5 CENTIMETERS OR LESS SKIN GROWTH OF THE TRUNK ARMS OR LEGS", "units": 1 } : null,
            insurance: useDefaults ? { "name": "BCBS-FL: FLORIDA BLUE", "type": "BCBS-FL", "isSelfPay": false } : null,
            provider: useDefaults ? { "name": "JEREMY WEINBERGER, MD", "type": "MD", "isPcp": false } : null,
            location: useDefaults ? { "departmentId": 4373, "name": "CFL_HFMG_Gateway Office STE 1A", "isFacility": false, "isTrauma": false } : null,
            sort: [
                {
                    field: "name",
                    dir: "asc",
                },
            ],
        };
    }

    componentDidMount() {
    }


    handleProcedureChange = (e) => {
        this.setState({
            procedure: e.value
        });
    }

    handleInsuranceChange = (e) => {
        this.setState({
            insurance: e.value
        });
    }

    handleProviderChange = (e) => {
        this.setState({
            provider: e.value
        });
    }

    handleLocationChange = (e) => {
        this.setState({
            location: e.value
        });
    }

    parametersAreValid = () => {
        return this.state.procedure && this.state.insurance && this.state.provider && this.state.location;
    }

    handleFilterChange = (e) => {
        this.setState({ filter: e.target.value }, this.filterData);
    }

    handlePageChange = (event) => {
        this.setState({
            skip: event.page.skip,
            take: event.page.take,
        });
    };

    getData = () => {
        this.setState({ isLoading: true });

        Api.getCodeFeeScheduleMapping(this.state.procedure.code, this.state.insurance, this.state.location, this.state.provider).then((results) => {
            results.forEach(item => {
                item.name = `${item.feeScheduleId} ${item.feeScheduleName}`;
                if (item.effectiveDate) {
                    item.effectiveDate = new Date(item.effectiveDate);
                }
                if (item.expirationDate) {
                    item.expirationDate = new Date(item.expirationDate);
                }
            });
            this.setState({ data: results, isLoading: false, showTable: true }, this.filterData);
        });
    }

    filterData = () => {
        if (this.state.filter) {
            const filteredData = filterBy(this.state.data.slice(), {
                logic: 'or',
                filters: [
                    { field: "name", operator: "contains", value: this.state.filter, ignoreCase: true },
                    { field: "feeScheduleId", operator: "contains", value: this.state.filter, ignoreCase: true },
                    { field: "feeScheduleName", operator: "contains", value: this.state.filter, ignoreCase: true },
                    { field: "amount", operator: "contains", value: this.state.filter, ignoreCase: true },
                ]
            });

            this.setState({
                currentData: filteredData
            });
        } else {
            this.setState({
                currentData: this.state.data.slice()
            })
        }
    }

    renderBoolCell = (props) => {
        const field = props.field || "";
        const value = props.dataItem[field];
        //const navigationAttributes = useTableKeyboardNavigation(props.id);
        //            {...navigationAttributes}

        //console.log(value);

        return (<td
            colSpan={props.colSpan}
            role={"gridcell"}
            aria-colindex={props.ariaColumnIndex}
            aria-selected={props.isSelected}
            {...{
                [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex,
            }}
        >
            {value ? (<h5 className="text-center"><span style={{ color: 'green' }} className="bi bi-check-circle-fill" /></h5>) : ""}
        </td>);
    }

    renderHeaderCellAlt = (props) => {
        const title = props.title || "";
        //const value = props.dataItem[title];
        //console.log(props);

        return (<div className="k-link" onClick={this.props.onClick}>
            <span title={title}>{title}</span>
            {this.props.children}
        </div>);
    }

    render() {
        const loadingPanel =
            <div className="k-loading-mask">
                <span className="k-loading-text">Loading</span>
                <div className="k-loading-image"></div>
                <div className="k-loading-color"></div>
            </div>

        return (
            <div className="container">
                <div className="row">
                    <div className="col-sm-12 col-md-6">
                        <h1 className="page-header">Troubleshooting</h1>
                    </div>
                </div>
                <div className="row">
                    <div className="card shadow">
                        <div className="card-body">
                            <div className="panel-body">
                                <div className="row form-group">
                                    <label className="control-label col-sm-2">Procedure Code</label>
                                    <div className="col-sm-4">
                                        <HfKendoComboBox
                                            id="addCodeComboBox"
                                            ref={this.addCodeModalInitFieldRef}
                                            delay={500}
                                            minLengthForSearch={3}
                                            api={Api.searchProcedures}
                                            dataItemKey="label"
                                            textField="label"
                                            value={this.state.procedure}
                                            onChange={this.handleProcedureChange}
                                            style={{ width: "100%" }}
                                        />
                                    </div>
                                </div>
                                <div className="row form-group">
                                    <label className="control-label col-sm-2">Insurance</label>
                                    <div className="col-sm-4">
                                        <HfKendoComboBox
                                            loadOnInit={true}
                                            api={Api.getInsurances}
                                            dataItemKey="name"
                                            textField="name"
                                            value={this.state.insurance}
                                            onChange={this.handleInsuranceChange}
                                            style={{ width: "100%" }}
                                        />
                                    </div>
                                </div>
                                <div className="row form-group">
                                    <label className="control-label col-sm-2">Provider</label>
                                    <div className="col-sm-4">
                                        <HfKendoComboBox
                                            loadOnInit={true}
                                            api={Api.getProviders}
                                            dataItemKey="name"
                                            textField="name"
                                            value={this.state.provider}
                                            onChange={this.handleProviderChange}
                                            style={{ width: "100%" }}
                                        />
                                    </div>
                                </div>
                                <div className="row form-group">
                                    <label className="control-label col-sm-2">Location</label>
                                    <div className="col-sm-4">
                                        <HfKendoComboBox
                                            loadOnInit={true}
                                            api={Api.getLocations}
                                            dataItemKey="name"
                                            textField="name"
                                            value={this.state.location}
                                            onChange={this.handleLocationChange}
                                            style={{ width: "100%" }}
                                        />
                                    </div>
                                </div>
                                <div className="row form-group">
                                    <div className="col-sm-2">
                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            disabled={!this.parametersAreValid()}
                                            onClick={this.getData}
                                        >Submit</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.isLoading && loadingPanel}
                {this.state.showTable &&
                    <div className="row">
                        <div className="card shadow">
                            <div className="card-body">
                                <div className="panel-body">
                                    <div className="row">
                                        <div className="col-sm-1">
                                            <label for="filter" className="col-form-label">Filter</label>
                                        </div>
                                        <div className="col-sm-3">
                                            <input id="filter" className="form-control" value={this.state.filter} onChange={this.handleFilterChange} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {this.state.isLoading && loadingPanel}
                {this.state.showTable &&
                    <div className="row">
                        <div className="card shadow">
                            <div id="troubleshooting-grid" className="card-body">
                                <Grid
                                    data={orderBy(this.state.currentData.slice(this.state.skip, this.state.take + this.state.skip), this.state.sort)}
                                    skip={this.state.skip}
                                    take={this.state.take}
                                    total={this.state.currentData.length}
                                    pageable={true}
                                    onPageChange={this.handlePageChange}
                                    rowRender={this.rowRender}
                                    sortable={true}
                                    sort={this.state.sort}
                                    onSortChange={(e) => {
                                        this.setState({
                                            sort: e.sort,
                                        });
                                    }}
                                >
                                    <GridColumn field="name" sortable={true} title="Schedule" />
                                    <GridColumn field="feeScheduleType" sortable={true} title="Type" />
                                    <GridColumn field="amount" sortable={true} format="{0:$0.00}" title="Amount" />
                                    <GridColumn field="isActiveSchedule" sortable={true} title="Active" cell={this.renderBoolCell} />
                                    <GridColumn title="Mapped">
                                        <GridColumn field="isMappedToIns" sortable={true} cell={this.renderBoolCell} title="Ins" />
                                        <GridColumn field="isMappedToDept" sortable={true} cell={this.renderBoolCell} title="Dept" />
                                    </GridColumn>
                                    <GridColumn title="Matched">
                                        <GridColumn field="matchesFacilityType" sortable={true} cell={this.renderBoolCell} title="Facility Type" />
                                        <GridColumn field="matchesProviderIsPcp" sortable={true} cell={this.renderBoolCell} title="Provider PCP" />
                                        <GridColumn field="matchesProviderType" sortable={true} cell={this.renderBoolCell} title="Provider Type" />
                                    </GridColumn>
                                </Grid>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}